var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeadPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_40965",
    "data-name": "Group 40965",
    transform: "translate(9478 23066)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_15549",
    "data-name": "Rectangle 15549",
    width: 24,
    height: 24,
    transform: "translate(-9478 -23066)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Online_Support",
    transform: "translate(-9475 -23064.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_37025",
    "data-name": "Path 37025",
    d: "M59.559,224.983a1.78,1.78,0,1,1-3.559,0v-3.2a1.78,1.78,0,1,1,3.559,0Z",
    transform: "translate(-56 -211.102)",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37026",
    "data-name": "Path 37026",
    d: "M379.559,224.983a1.78,1.78,0,1,1-3.559,0v-3.2a1.78,1.78,0,1,1,3.559,0Z",
    transform: "translate(-361.763 -211.102)",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37027",
    "data-name": "Path 37027",
    d: "M56,30.678V28.9a8.9,8.9,0,1,1,17.8,0v1.78",
    transform: "translate(-56 -20)",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37028",
    "data-name": "Path 37028",
    d: "M303.119,332v1.78a3.559,3.559,0,0,1-3.559,3.559H296",
    transform: "translate(-285.322 -318.119)",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2907",
    "data-name": "Ellipse 2907",
    cx: 1.78,
    cy: 1.78,
    r: 1.78,
    transform: "translate(7.119 17.441)",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeadPhone);
export default __webpack_public_path__ + "static/media/head-phone.4dd2b6308273266225edaa6897816acb.svg";
export { ForwardRef as ReactComponent };